<template lang="html">

	<div class="wrapper encuesta" :style="styles.backgroundWhite">
		
		<h2 class="ficha-title" :style="styles.colorBasic">{{$t('resultados_informe')}}</h2>

		<div class="resultados" v-if="!!datos">

			<template v-for="(pregunta,key) in datos">

				<div class="contenedor-respuesta">

					<h4 class="data-title" :style="styles.colorBasic" v-html="key+1+'. '+pregunta.enunciado"></h4>

					<template v-for="(respuesta,keyRespuesta) in pregunta.respuestas">

						<p v-if="!!respuesta.texto">{{respuesta.texto}}</p>

						<p>
							<template v-if="!!respuesta.opcionElegida">{{respuesta.opcionElegida}}</template>
							<template v-if="!!respuesta.valoracion">: {{respuesta.valoracion}}</template>
						</p>

						<arrow-link v-if="!!respuesta.urlArchivo" :text="$t('ver_documento_adjunto')" :to="respuesta.urlArchivo" :external="true" :blank="true"></arrow-link>

					</template>

				</div>	

			</template>

		</div>

		<loading v-else></loading>

	</div>


</template>

<script lang="js">
	
	import {mapGetters,mapActions} from 'vuex';

	import arrowlink  from '@/components/parts/icons/arrow-link';

	import loading from '@/components/parts/loading';

	export default  {
		name: 'encuesta',
		props: ['id'],
		mounted(){
			this.getEncuesta();
		},
		computed :{
			...mapGetters({
				styles : 'getStyles',
				colors : 'basicColors',
			}),
		},
		components : {
			'arrow-link' : arrowlink,
			'loading' : loading
		},
		methods :{
			...mapActions(['dameContestacionEncuesta']),
			getEncuesta : function(){

				let id = (!!!this.id) ? this.$route.params.id : this.id;

				this.dameContestacionEncuesta(id).then(r=>{
					this.datos = r;
				})
			}
		},
		data(){
			return{
				datos: ''
			}
		},
		watch : {
			'id'(){
				this.getEncuesta();
			}
		}
	}
</script>

<style scoped lang="scss">
	.encuesta {
		width: 100%;
		height: 100%;
		overflow: hidden;
		padding: 20px;
		position: relative;
	}

	.wrapper-content > .wrapper.encuesta{
		max-width: 768px;
		margin: 0 auto;
	}

	[full=true]{
		.encuesta{
			max-width: 100%;
		}
	}

	.ficha-title{
		max-width: 768px;
		margin: 10px auto;
	}

	.resultados{
		max-height: calc(100vh - 173px);
		overflow: scroll;
		overflow-x: hidden;
		padding-bottom: 20px;
	}

	.data-title{
		text-align: left;
		margin-bottom: 3px;
		width: 100%;
		display: inline-block;
		font-size: 16px;
		font-weight: 700;
	}

	.contenedor-respuesta{
		margin: 0 auto;
		margin-bottom: 10px;
		max-width: 768px;
		&:last-of-type{
			margin-bottom:0;
		}
	}
	
	p{
		text-align: left;
		margin-bottom: 5px;
		width: 100%;
		display: inline-block;
		font-size: 14px;
	}

	@media screen and (max-width: 1400px){
		.resultados{
			max-height: calc(100vh - 173px);
		}
	}

	@media screen and (max-width: 1023px){
		.resultados{
			max-height: calc(100vh - 158px);
		}
	}

	@media screen and (max-width: 600px){
		.data-title{
			font-size: 16px;
		}
	}

	@media screen and (max-width: 430px){
		.encuesta{
			padding: 20px 10px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/vista-encuesta.vue